import { forwardRef, Ref, type SVGProps } from 'react';

const SvgSupportersIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 28 32"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#supporters-icon_svg__a)">
      <path d="M27.176 31.854H17.137a3.552 3.552 0 0 0-7.098 0H0c0-5.671 3.474-10.53 8.41-12.566a13.5 13.5 0 0 1 5.178-1.022c1.834 0 3.583.363 5.18 1.022 4.935 2.036 8.408 6.895 8.408 12.566M18.912 0v7.4h8.264V0zm8.264 1.566v1.746h-4.132zM8.264 0v7.37H0V3.529h4.646L0 1.566V0z" />
      <path d="M27.177 6.722c0 7.504-6.084 13.587-13.588 13.588S0 14.227 0 6.722h8.265a5.324 5.324 0 0 0 10.647 0z" />
      <path d="M13.589 10.386a4.125 4.125 0 1 0 0-8.25 4.125 4.125 0 0 0 0 8.25" />
    </g>
    <defs>
      <clipPath id="supporters-icon_svg__a">
        <path d="M0 0h27.176v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgSupportersIcon);
export default ForwardRef;
